const paths = {
  physicalWellbeing: {
    es: 'bienestar-fisico',
    en: 'physical-wellbeing',
    it: 'benessere-fisico',
    pt: 'bem-estar-fisico',
  },

  mentalHealth: {
    es: 'mente-sana',
    en: 'mental-health',
    it: 'benessere-mentale',
    pt: 'saude-mental',
  },

  selfawareness: {
    es: 'autoconocimiento',
    en: 'self-awareness',
    it: 'conoscenza-di-se',
    pt: 'autoconhecimento',
  },

  noMoreViolence: {
    es: 'ni-una-menos',
    en: 'hear-me-too',
    it: 'quella-volta-che',
    pt: 'por-nossa-voz',
  },

  reflections: {
    es: 'reflexiones',
    en: 'reflections',
    it: 'riflessioni',
    pt: 'reflexões',
  },

  others: {
    es: 'otros',
    en: 'others',
    it: 'altrui',
    pt: 'outros',
  },
};

export default paths;
